// extracted by css-extract-rspack-plugin
export default {"ListItemTitle_0":"CommitRow-module__ListItemTitle_0__cUhJS","ListItem_0":"CommitRow-module__ListItem_0__u0LMo","ListItemMetadata_0":"CommitRow-module__ListItemMetadata_0__W4Kqf"};